import { Controller, Get, Query, UseGuards } from '@nestjs/common';
import { AuthGuard } from '../auth/auth.guard';
import { DemoModeGuard } from '../auth/demo-mode.guard';
import { PlatformService } from './platform.service';

@Controller('platform/permissions')
@UseGuards(AuthGuard, DemoModeGuard)
export class PermissionsController {
  constructor(private readonly platformService: PlatformService) {}

  @Get()
  listPermissions(@Query('scope') scope?: string) {
    return this.platformService.listPermissions(scope);
  }
}
